import { assertUnreachable } from '@/utils';

import actionCreators from './action-creators';

export const initialState = {
  isAutoCompleting: false,
  inputValue: '',
};

type State = typeof initialState;
type Action = ReturnType<typeof actionCreators[keyof typeof actionCreators]>;

export default function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'SET_INPUT_VALUE':
      return { ...state, inputValue: action.payload };
    case 'CLEAR_INPUT_VALUE':
      return { ...state, inputValue: '' };
    case 'SET_AUTOCOMPLETING':
      return { ...state, isAutoCompleting: action.payload };
    default:
      return assertUnreachable(action);
  }
}
